import { H_Container } from "./Header.styled";
import { ServiceName } from "../../../../../../../../constants";

interface HeaderProps {
	service: ServiceName;
	sort: number
}

export const Header = ({ service, sort }: HeaderProps) => {
	return <H_Container $service={service}>Course {sort || 1}</H_Container>;
};
